export default "__VITE_ASSET__9eacb0f4__"